import * as z from "zod/v4";

const appUsage = z.object({ appTitle: z.string(), usage: z.int() });

export const getFulfillmentBreakdown = {
  name: "getFulfillmentBreakdown" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ breakdown: z.array(appUsage) }),
};
